import cn from "classnames";
import { ContractMenuList, Option, ValueContainer } from "components/shared/baseBidForm";
import { CargoOwnerDocsForm } from "components/shared/cargoOwnerDocs";
import { CargoOwnerShareAccess } from "components/shared/cargoOwnerShareAccess";
import { counterpartyInsolvency } from "helpers/bid";
import { bidStatusesEnum, sourceTypesEnum } from "helpers/enums";
import { HiddenDataWrapper } from "helpers/hiddenData";
import { ymEvent } from "helpers/system";
import React, { Fragment, useEffect, useState } from "react";
import { list as counterpartyContracts } from "sources/books/counterpartyContracts";
import { count } from "sources/books/legalPersons";
import LegalPersonBankAccountSelect from "./legalPersonBankAccountSelect";

const MainData = ({
    renderField,
    renderSelect,
    renderCheckbox,
    renderDateField,
    config,
    bidPolicy,
    documents,
    setValue,
    documentsExists,
    isEmptyMileageBid,
    temperatureRegimeEnabled,
    temperatureRegime,
    counterpartyComment,
    counterpartyInsolvencyRegistryEntry,
    cargoOwnerDictionaryItemId,
    values,
    isNewForm,
    trackEmptyMileageBidTypesEnabled,
    modal,
    roles,
    profile,
    organization,
}) => {
    const [legalPersonCount, setLegalPersonCount] = useState(0);
    const { legalPersonId } = values;
    useEffect(() => {
        count().then((res) => setLegalPersonCount(res.count || 0));
    }, []);
    const { temperatureMinimum, temperatureMaximum } = config.temperatureRegime.config;
    const getTemperatureRegimeProps = (temperatureConfig) => ({
        ...temperatureConfig,
        validators: [
            (value) => temperatureConfig.validators.map((validator) => validator(value, { temperatureRegime })),
        ],
        value:
            temperatureRegime[temperatureConfig.inputProps.name] != null
                ? temperatureRegime[temperatureConfig.inputProps.name]
                : "",
        onChange: ({ name, value }) =>
            setValue({ name: "temperatureRegime", value: { ...temperatureRegime, [name]: value } }),
        fieldWrapper: "col-sm-8 col-md-5",
        bWrapper: "row form-group",
    });
    const renderDocuments = () => {
        return (
            <div className="row form-group">
                <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                    Документы
                </label>
                <div className="col-sm-8 col-md-9">
                    <CargoOwnerDocsForm documents={documents} setValue={setValue} />
                </div>
            </div>
        );
    };

    const onChangeEmptyMileageBid = ({ name, value }) =>
        setValue({ name: "emptyMileageBid", value: { ...(values.emptyMileageBid ?? {}), [name]: value } });
    return (
        <>
            <div className="form-group">
                <strong>Общие параметры</strong>
            </div>
            {!isEmptyMileageBid &&
                renderSelect({
                    ...config.responsibleId,
                    disabled: !bidPolicy.canChangeResponsible(),
                    fieldWrapper: "col-sm-8 col-md-5",
                    bWrapper: "row form-group",
                })}
            {!isEmptyMileageBid &&
                bidPolicy.canSeeSalesManager() &&
                renderSelect({
                    ...config.salesManagerId,
                    disabled: !bidPolicy.canChangeResponsible(),
                    fieldWrapper: "col-sm-8 col-md-5",
                    bWrapper: "row form-group",
                })}
            {!isEmptyMileageBid &&
                legalPersonCount >= 1 &&
                renderSelect({
                    ...config.legalPersonId,
                    fieldWrapper: "col-sm-8 col-md-5",
                    bWrapper: "row form-group",
                })}
            {!isEmptyMileageBid && (
                <LegalPersonBankAccountSelect
                    legalPersonId={legalPersonId}
                    value={values.legalPersonBankAccountId}
                    setValue={setValue}
                    renderSelect={renderSelect}
                    config={config}
                />
            )}
            {renderCheckbox(config.isEmptyMileageBid)}
            {isEmptyMileageBid &&
                trackEmptyMileageBidTypesEnabled &&
                (isNewForm || values.sourceType === sourceTypesEnum.Web) &&
                renderSelect({
                    ...config.emptyMileageBid.config.logisticReasonTypeId,
                    fieldWrapper: "col-sm-8 col-md-5",
                    bWrapper: "row form-group",
                    onChange: onChangeEmptyMileageBid,
                    value: values.emptyMileageBid?.logisticReasonTypeId,
                })}
            {!isEmptyMileageBid &&
                (!values.status || values.status === bidStatusesEnum.New || values.isPreBibByInitial) &&
                renderCheckbox(config.isPreBid)}
            <HiddenDataWrapper>
                <>
                    {!isEmptyMileageBid &&
                        bidPolicy.isOwner() &&
                        bidPolicy.isCargoTruck() &&
                        renderSelect({
                            ...config.cargoOwnerDictionaryItemId,
                            modal,
                            roles,
                            profile,
                            organization,
                            fieldWrapper: "col-sm-8 col-md-5",
                            inputBottomText: (
                                <>
                                    <div>{counterpartyInsolvency(counterpartyInsolvencyRegistryEntry)}</div>
                                    <small>
                                        <i className="text-muted">{counterpartyComment}</i>
                                    </small>
                                </>
                            ),
                        })}
                    {bidPolicy.canSeeCargoOwnerShareAccessInEdit() && (
                        <>
                            <div className="row form-group">
                                <div className="col-auto offset-sm-4 offset-md-3 d-flex align-items-center">
                                    <div
                                        className="btn btn-sm btn-brand d-flex align-items-center"
                                        onClick={() => {
                                            setValue({ name: "shareAccessEnabled", value: !values.shareAccessEnabled });
                                            ymEvent("shareonbuildform");
                                        }}
                                    >
                                        <span
                                            className={cn("checkbox checkbox--inline mr-2", {
                                                "checkbox--checked": values.shareAccessEnabled,
                                            })}
                                            name="shareAccessEnabled"
                                        />
                                        Предоставить доступ к заявке клиенту
                                    </div>
                                    <a
                                        className="show-bid__section-header--tooltip ml-2"
                                        href="https://cargorun.ru/articles/obnovlieniie-sistiemy-cr-zaghruzki-ot-21-tochka-09-tochka-2023"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        ?
                                    </a>
                                </div>
                            </div>
                            {values.shareAccessEnabled && (
                                <div className="row">
                                    <div className="offset-sm-4 offset-md-3 col-sm-8 col-md-5">
                                        <div className="card card-body mb-3">
                                            <CargoOwnerShareAccess
                                                controlled
                                                config={{
                                                    ...config.cargoOwnerShareAccess.config,
                                                    contactPerson: config["cargoOwnerShareAccess.contactPerson"],
                                                }}
                                                setValue={({ name, value }) =>
                                                    setValue({
                                                        name: "cargoOwnerShareAccess",
                                                        value: { ...values.cargoOwnerShareAccess, [name]: value },
                                                    })
                                                }
                                                values={values.cargoOwnerShareAccess}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </>
            </HiddenDataWrapper>
            {!isEmptyMileageBid && (
                <Fragment key={`${cargoOwnerDictionaryItemId}_${legalPersonId}`}>
                    {renderSelect({
                        ...config.contractId,
                        fieldWrapper: "col-sm-8 col-md-5",
                        bWrapper: "row form-group",
                        disabled: !cargoOwnerDictionaryItemId,
                        components: { ValueContainer, Option, MenuList: ContractMenuList },
                        counterpartyId: cargoOwnerDictionaryItemId,
                        legalPersonId,
                        modal,
                        organization,
                        roles,
                        url: (params) =>
                            counterpartyContracts({
                                counterpartyId: cargoOwnerDictionaryItemId,
                                legalPersonId,
                                ...params,
                            }),
                    })}
                </Fragment>
            )}
            {!isEmptyMileageBid &&
                renderField({
                    ...config.contractNumber,
                    fieldWrapper: "col-sm-8 col-md-5",
                    bWrapper: "row form-group",
                })}
            {!isEmptyMileageBid && documentsExists && renderDocuments()}
            {!isEmptyMileageBid &&
                bidPolicy.canEditAsCargo() &&
                !bidPolicy.isCargoTruck() &&
                renderSelect({ ...config.partnerId, fieldWrapper: "col-sm-8 col-md-5" })}
            {temperatureRegimeEnabled && (
                <>
                    <Fragment key={`temperatureMinimum_${temperatureRegime.temperatureMaximum}`}>
                        {renderField({ ...getTemperatureRegimeProps(temperatureMinimum) })}
                    </Fragment>
                    <Fragment key={`temperatureMaximum_${temperatureRegime.temperatureMinimum}`}>
                        {renderField({ ...getTemperatureRegimeProps(temperatureMaximum) })}
                    </Fragment>
                </>
            )}
            {bidPolicy.canSeeDocumentAssignment() && renderCheckbox(config.createDocumentAssignment)}
            {renderCheckbox(config.showDraftInPlanning)}
            {renderField({ ...config.comment, fieldWrapper: "col-sm-8 col-md-5", bWrapper: "row form-group" })}
            {renderField({ ...config.clientBidNumber, fieldWrapper: "col-sm-8 col-md-5", bWrapper: "row form-group" })}
            {renderDateField({ ...config.clientBidDate, wrapper: "col-sm-8 col-md-5", bWrapper: "row form-group" })}
        </>
    );
};

export default MainData;
